module.exports = __webpack_public_path__ + "img/vertical_4_4_2.292141bf.png";